export const addBooking = (id) => {
    return {
        type: "booking/add", payload: { ...id }
    };
};

export const removeBooking = (id) => {
    return {
        type: "booking/remove", payload: { id }
    };
};
